import React from "react";
import { useRoutes, Navigate } from "react-router-dom";
import { usePromiseTracker } from "react-promise-tracker";

import GlobalStyles from "./components/GlobalStyles";
import AppLayout from "./layouts/AppLayout";
import ProjectDetail from "./pages/ProjectDetail";
import RecordingDetail from "./pages/RecordingDetail";
import FlowDetail from "./pages/FlowDetail";
import AuthLayout from "./layouts/AuthLayout";
import LoginView from "./pages/LoginView";
import useAuth from "./hooks/useAuth";
import PlayerLayout from "./layouts/PlayerLayout";
import PlayerView from "./pages/PlayerView";
import AppLoader from "./components/AppLoader";
import CreateRecordingView from "./pages/CreateRecordingView";

const AppRouter = () => {
  const { isAuthenticated } = useAuth();
  const element = useRoutes([
    {
      path: "/",
      element: isAuthenticated ? (
        <AppLayout />
      ) : (
        <Navigate to={`/login?redirectUrl=${window.location.pathname}`} />
      ),
      children: [
        {
          path: "/project/:projectId",
          element: <ProjectDetail />,
        },
        {
          path: "/project/:projectId/new-recording",
          element: <CreateRecordingView />,
        },
        {
          path: "/recording/:recordingId",
          element: <RecordingDetail />,
        },
        {
          path: "/flow/:workflowId",
          element: <FlowDetail />,
        },
      ],
    },
    {
      path: "/",
      // Disabled authentication for this url alone
      element: <PlayerLayout />,
      children: [
        {
          path: "/player/flow/:flowId",
          element: <PlayerView />,
        },
      ],
    },
    {
      path: "/",
      element: <AuthLayout />,
      children: [
        {
          path: "/login",
          element: <LoginView />,
        },
      ],
    },
  ]);

  return element;
};

const App = () => {
  const { promiseInProgress } = usePromiseTracker();
  return (
    <>
      <GlobalStyles />
      <AppLoader show={promiseInProgress} type="CIRCULAR" />
      <AppRouter />
    </>
  );
};

export default App;
